import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {User} from "../../models/User"

export const userFields: IntercateKeysMap<User, EntityField<User>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id korisnika",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    firstName: {
		name: "firstName", dataType: EntityFieldDataType._string, label: "Ime",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    lastName: {
		name: "lastName", dataType: EntityFieldDataType._string, label: "Prezime",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    email: {
		name: "email", dataType: EntityFieldDataType._string, label: "Email",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    password: {
		name: "password", dataType: EntityFieldDataType._string, label: "Lozinka",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    roleId: {
		name: "roleId", dataType: EntityFieldDataType._reference, label: "Uloga",
        referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Roles
		},
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    isAdmin: {
		name: "isAdmin", dataType: EntityFieldDataType._boolean, label: "Da li je administrator",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    positionId: {
        name: "positionId", dataType: EntityFieldDataType._reference, label: "Pozicija",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Positions
		},
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    role: {
        name: "role", dataType: EntityFieldDataType._reference, label: "Uloge",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Roles
		},
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    uploads: {
        name: "uploads", dataType: EntityFieldDataType._reference, label: "Uploads",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Uploads
		},
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    roles: {
		name: "roles", dataType: EntityFieldDataType._reference, label: "Dodeljene uloge",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.DepartmentRoles
		},
		validator: { required: false },
		sortable: true
	},
}

const userFieldsArray: Array<EntityField<User>> = [
	userFields.email,
    userFields.firstName,
    userFields.lastName,
    userFields.roleId,
    userFields.password,
    userFields.positionId,
]

export const userFieldsDescriptor: EntityFieldsDescriptor<User> = {
	listFields: userFieldsArray,
	createFormFields: userFieldsArray,
	updateFormFields: userFieldsArray
}